<template>
  <div id="app">
     <keep-alive>
       <router-view v-if="$route.meta.keepAlive"/>
     </keep-alive>
     <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,body{
  margin: 0;
  padding: 0;
  border:0;
  font-family:"微软雅黑", "Microsoft YaHei", Arial, "PingFang SC", "helvetica", sans-serif;
  font-size:14px;
  vertical-align:middle;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue